/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

import { Splide } from '../vendor/splide.esm';

const defaultslider = () => {
  const sliders = document.querySelectorAll('.slider-splide-js');
  sliders.forEach(item => {
    const splide = new Splide(item);
    splide.mount();
  });
};

export default defaultslider;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/defaultslider.js